<div class="card mb-0" style="width: 700px;">
  <div class="card-body" style="padding: 36px 40px">
      <h3  *ngIf="isCreated" class="card-title">
            Add Employee to Location
      </h3>
      <h3  *ngIf="!isCreated" class="card-title">
            Edit Employee
      </h3>
      <!-- <h4 class="card-subtitle">
        Select your date range
      </h4>
    
      <p class="card-info">
        Exports are limited to max 100 contacts per export. If you need to export more than 100 contacts, you can perform multiple exports or contact Support for assistance.
      </p> -->
      <form 
        [formGroup]="employeeForm " 
        (ngSubmit)="save()" 
        style="color:#495057!important ">
        <div class="mb-3">
          <label for="employeeName" class="form-label">First Name</label>
          <input
            type="text"
            class="form-control"
            id="employeeName"       
            formControlName="firstName" />
          <div *ngIf="employeeForm.get('firstName').touched && employeeForm.get('firstName').invalid" class="text-danger mt-1" style="font-size: 0.875rem;">
            <span *ngIf="employeeForm.get('firstName').errors?.['required']">First name is required</span>
            <span *ngIf="employeeForm.get('firstName').errors?.['blank']">First name cannot be blank</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="employeeLastName" class="form-label">Last Name</label>
          <input
            type="text"
            class="form-control"
            id="employeeLastName"
            formControlName="lastName" />
          <div *ngIf="employeeForm.get('lastName').touched && employeeForm.get('lastName').invalid" class="text-danger mt-1" style="font-size: 0.875rem;">
            <span *ngIf="employeeForm.get('lastName').errors?.['required']">Last name is required</span>
            <span *ngIf="employeeForm.get('lastName').errors?.['blank']">Last name cannot be blank</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="employeeTitle" class="form-label">Title</label>
          <input
            type="text"
            class="form-control"
            id="employeeTitle"
            formControlName="title" />
        </div>  
        <!-- <div
          *ngIf="(campaigns$ | async).length > 0"
          class="mb-3"
        >
          <label class="form-label">Campaigns</label>
          <div>
              <app-campaign-dropdown
                  [campaignsBasicInfo]="campaigns$ | async"
                  [multiSelect]="false"
                  [selectedCampaigns]="selectedCampaignStart"
                  (onSelect)="changeCampaign($event)"
              />
          </div>
      </div> -->
      </form>

      <div class="card-btn">
          <button
            type="button"
            class="btn btn-primary"
            style="font-weight: 400"
            (click)=" isCreated ? save() : update()"
            [disabled]="employeeForm.invalid || isLoading" 
          >
            Save
          </button>
          <button
            class="btn btn-outline-secondary"
            type="button"
            style="font-weight: 400"
            (click)="activeModal.dismiss()"
            [disabled]="isLoading"
          >
            Cancel
          </button>
      </div>

      <!-- Loading overlay -->
      <div *ngIf="isLoading" style="position: absolute; inset: 0; background: rgba(255,255,255,0.6); display:flex; align-items:center; justify-content:center; z-index: 50;">
        <div style="text-align:center;">
          <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div style="margin-top: 0.5rem; font-weight: 500;">Saving...</div>
        </div>
      </div>

<!-- PrimeNG dialog for success/error -->
<p-dialog [(visible)]="showResultDialog" [modal]="true" [closable]="false" [dismissableMask]="true" [style]="{width: '360px'}">
  <ng-template pTemplate="header">
    {{ resultTitle }}
  </ng-template>
  <div class="p-d-flex p-jc-center p-ai-center" style="padding: 1rem;">
    <div style="text-align: center;">
      <div style="font-size: 1.1rem; margin-bottom: 0.5rem;">
        {{ resultMessage }}
      </div>
      <button pButton type="button" label="OK" class="p-button p-component p-button-text" (click)="closeResultDialog()"></button>
    </div>
  </div>
</p-dialog>
  </div>
</div>
